import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceSad24Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFaceSad24Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M8.75 11a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m7.75-1.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-9.26 7.953a.75.75 0 0 0 .962-.438l.003-.009.025-.057a3 3 0 0 1 .128-.242c.122-.207.317-.49.605-.772.563-.552 1.504-1.135 3.037-1.135s2.474.583 3.037 1.135c.288.283.483.565.605.773a3 3 0 0 1 .153.298l.004.01a.75.75 0 0 0 1.404-.526L16.5 17l.703-.261v-.001l-.001-.002-.002-.005-.005-.012-.014-.036-.05-.114a4 4 0 0 0-.195-.37 5.3 5.3 0 0 0-.848-1.084c-.812-.798-2.12-1.565-4.088-1.565s-3.276.767-4.088 1.565c-.4.393-.673.785-.848 1.084a4 4 0 0 0-.26.52l-.004.012-.002.005v.002h-.001c0 .001 0 .002.703.262l-.703-.26a.75.75 0 0 0 .443.963"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFaceSad24Filled);
